import { Icon } from '@cash-me/react-components'
import styled from 'styled-components'

import { theme } from 'styles/theme'

const { colors, media, space, zIndices, fontSizes } = theme

export const Hero = styled.section`
  position: relative;
  background-color: ${colors['neutral-background-default']};
  overflow: hidden;
  padding-top: ${space['spacing-lg']};

  & > div > div:first-child{
    order: 2;
  }

  & > div > div:last-child{
    order: 1;
  }

  @media (${media.tablet}) {
    padding-top: ${space['spacing-xxxl']};
    padding-bottom: ${space['spacing-xxxl']};
    overflow: visible;

    & > div > div:first-child{
      order: 1;
    }
    
    & > div > div:last-child{
      order: 2;
    }
  }
`

export const ImageWrapper = styled.div`
  position: relative;
  width: 75%;
  margin: ${space['spacing-xxl']} ${space['spacing-xxl']} ${space['spacing-xxl']} 0 ;

  @media (${media.tablet}) {
    margin: 0;
  }
`

export const Image = styled.div`
  position: relative;
  top: ${space['spacing-xs']};
  top: 0;
  width: 100%;

  @media (${media.tablet}) {
    position: absolute;
    z-index: 1;
    right: 0;
  }
`

export const Infos = styled.div`
  position: relative;
  z-index: ${zIndices[1]};

  h1 {
    margin-bottom: ${space['spacing-lg']};
  }

  > p {
    margin-bottom: ${space['spacing-md']};
  }

  .ds-button {
    margin: ${space['spacing-md']} 0;
  }

  @media (${media.tablet}) {
    top: 32px;
    margin-bottom: ${space['spacing-md']};

    .ds-button {
      display: flex;
      width: 19rem;
    }

    > p {
      margin-bottom: ${space['spacing-md']};
    }
  }

  @media (${media.desktop}) {
    h1,
    h1 span {
      font-size: ${fontSizes['font-size-heading-2']};
    }

    > p {
      font-size: ${fontSizes['font-size-body-1']};
    }
      
    .disclaimer {
      font-size: ${fontSizes['font-size-body-2']};
    }
  }
`

export const LoanInfos = styled.ul`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space['spacing-md']};

  @media (${media.tablet}) {
    gap: ${space['spacing-sm']};
    margin-bottom: ${space['spacing-md']};

    & + p {
      margin-bottom: ${space['spacing-xl']};
    }
  }

  @media (${media.desktop}) {
    gap: ${space['spacing-md']};
  }
`

export const LoanInfosItem = styled.li`
  @media (${media.tablet}) {
    display: flex;
    align-items: center;
    gap: ${space['spacing-sm']};

    p {
      color: ${colors['neutral-text-weak']};
      font-size: ${fontSizes['font-size-body-1']};
    }
  }
`

export const LoanInfosIcon = styled(Icon)`
  margin-bottom: ${space['spacing-xxs']};

  @media (${media.tablet}) {
    margin-bottom: 0;
  }
`
